import { ViewportScroller } from '@angular/common';
import { Injectable, OnDestroy } from '@angular/core';
import { Event, Router, Scroll } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScrollPositionRestorationService implements OnDestroy {
  position: [number, number] | undefined | null;

  private subscription = new Subscription();

  constructor(
    router: Router,
    private viewportScroller: ViewportScroller,
  ) {
    this.subscription.add(
      router.events.pipe(filter((e: Event) => e instanceof Scroll)).subscribe((e) => {
        this.position = (e as Scroll).position;
      }),
    );
  }

  forceRestoreScrollPosition(): void {
    if (this.position) {
      this.viewportScroller.scrollToPosition(this.position);
      this.position = null;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
